import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator.jsx";
import DatasourceBaseTextFields from "./DatasourceBaseTextFields.jsx";

const DatasourceSpottLIVE = (props) => {

    const Fields = [
        {Identifier:"ApiKey", Translation:Translate("API key"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceSpottLIVE.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceSpottLIVE